export const msalConfig = {
    auth: {
      clientId: "bb86c3f2-d20b-4c2b-9d47-7be397ab80d9",
      authority: "https://login.microsoftonline.com/3dc50bd8-1608-403b-a3fb-dcb2881b5c76",
      redirectUri: "/",
    }
  };
  
  export const loginRequest = {
    scopes: ["User.Read", "Group.ReadWrite.All", "Directory.ReadWrite.All"]
  };
  